import { render, staticRenderFns } from "./JournalEintragTemplateModal.vue?vue&type=template&id=470e4638"
import script from "./JournalEintragTemplateModal.vue?vue&type=script&lang=js"
export * from "./JournalEintragTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports